import React, {useEffect, useState} from 'react'
import {Navigate, useNavigate} from 'react-router-dom'
import {Button, Container, Form, Grid, Header, Rating, Segment} from 'semantic-ui-react'
import {useAuth} from '../context/AuthContext'
import {handleLogError} from '../misc/Helpers'
import {reviewApi} from '../misc/ReviewApi'
import {tripApi} from '../misc/TripApi'
import {authApi} from '../misc/AuthApi'
import {useParams} from "react-router";

function ReviewFormPage() {
  const Auth = useAuth()
  const user = Auth.getUser()
  const isUser = user.role === 'USER'
  const navigate = useNavigate()

  const {tripId} = useParams()
  const {userId} = useParams()

  const [trip, setTrip] = useState('')
  const [target, setTarget] = useState('')
  const [mark, setMark] = useState('')
  const [notes, setNotes] = useState('')

  useEffect(() => {
    getTrip()
  }, [])

  const getTrip = async () => {
    try {
      const trip = await tripApi.getTrip(user, tripId)
      setTrip(trip.data)
      const target = await authApi.getUserById(user, userId)
      setTarget(target.data)
    } catch (error) {
      handleLogError(error)
    }
  }

  const handleCreateReview = async () => {
    try {
      const review = {
        mark: mark, notes: notes, tripId: trip.id, targetId: target.id
      }
      await reviewApi.createReview(user, review)
      navigate('/')
    } catch (error) {
      handleLogError(error)
    }
  }

  const handleInputChange = (e, {name, value}) => {
    if (name === 'notes') {
      setNotes(value)
    }
  }

  const handleRate = (e, {rating, maxRating}) => {
    setMark(rating);
  }
  if (!isUser) {
    return <Navigate to='/'/>
  }

  return (
    <Container>
      <Header as='h1' textAlign='center'>Отзыв на {target.name} с поездки {trip.fromCity} - {trip.toCity}</Header>
      <Grid textAlign='center'>
        <Grid.Column style={{maxWidth: 450}}>
          <Form size='large' onSubmit={handleCreateReview}>
            <Segment>
              <Rating icon="star" maxRating={5} onRate={handleRate}/>
              <Form.TextArea
                label='Отзыв'
                name={'notes'}
                value={notes}
                onChange={handleInputChange}
              />
              <Button size='large' color='blue'>
                Сохранить
              </Button>
            </Segment>
          </Form>
        </Grid.Column>
      </Grid>
    </Container>
  )
}

export default ReviewFormPage
